import { BridgeCallHandlers } from "@/interfaces/enums";
import bridge from "@/utils/dsBridge";
import rfStore from "@/utils/rfStore";
import { compareVersion } from "@/utils/util";
import React from "react";
import { useLongPress } from "use-long-press";
const LONG_PRESS_SUPPORT_VERSION = "6.2.5";

export default function LongPressContainer({ children }: { children: React.ReactNode }) {
	const onLongPress = (data: { element: string; content: string; [key: string]: any }) => {
		const isAndroid = rfStore.getRFState()?.model === "android";
		if (isAndroid) {
			const appVersion = rfStore.getRFState()?.appVersion || "";
			const isSupport = compareVersion(appVersion, LONG_PRESS_SUPPORT_VERSION) >= 0;
			if (!isSupport) return;
		}

		bridge.call(BridgeCallHandlers.ON_WEB_LONG_PRESS, data);
	};

	const bind = useLongPress(
		(event) => {
			const target = event.target as HTMLElement;
			let content = "";
			let additionalProps: { [key: string]: any } = {};

			if (target.tagName === "IMG") {
				content = (target as HTMLImageElement).src;
				additionalProps.alt = (target as HTMLImageElement).alt;
			} else if (target.tagName === "A") {
				content = (target as HTMLAnchorElement).href;
			} else if (target.tagName === "BUTTON" || target.tagName === "INPUT") {
				content = (target as HTMLButtonElement).innerText || (target as HTMLInputElement).value;
			} else {
				content = target.innerText;
			}

			// 获取所有属性
			const attributes = target.attributes;
			for (let i = 0; i < attributes.length; i++) {
				const attr = attributes[i];
				additionalProps[attr.name] = attr.value;
			}

			if (target.tagName !== "INPUT" && target.tagName !== "TEXTAREA") {
				event.preventDefault(); // 阻止默认行为
				onLongPress({
					element: target.tagName,
					content,
					...additionalProps,
				});
			}
		},
		{
			// threshold: 500, // 长按触发的时间阈值，单位为毫秒
			captureEvent: true, // 是否捕获事件对象
			cancelOnMovement: true, // 是否在移动时取消长按
		},
	);

	return (
		<div className="w-full h-full select-none" id="RF_LONG_CONTAINER" {...bind()}>
			{children}
		</div>
	);
}
